import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPaperclip } from 'react-icons/fa';

import { ouvrirJustificatif } from './justificatif';
import { signalerErreur } from '../../components/Utils/signalerErreur';

/**
 * Les pièces jointes d'une demande, dans les listes (Yros/Kavero#431) : une
 * ligne par pièce, qui l'ouvre dans un nouvel onglet. Rien à afficher sans
 * pièce. Sert le salarié comme la RH : c'est la même route, et Odoo juge qui
 * lit — le salarié de la demande, ou la RH de sa société.
 */
function PiecesJointes({ demande, className = '' }) {
  const { t } = useTranslation();
  const [erreur, setErreur] = useState(false);
  const pieces = demande?.contenu?.justificatifs || [];
  if (!pieces.length) return null;

  const voir = async (piece) => {
    setErreur(false);
    try {
      await ouvrirJustificatif(demande, piece);
    } catch (e) {
      signalerErreur(e, 'PiecesJointes.voir');
      setErreur(true);
    }
  };

  return (
    <span className={`flex flex-col gap-1 ${className}`}>
      <span className="flex flex-wrap gap-x-3 gap-y-1">
        {pieces.map((piece) => (
          <button
            key={piece.id}
            type="button"
            data-testid={`pieces-jointes-${demande.id}-${piece.id}`}
            onClick={() => voir(piece)}
            aria-label={`${t('piecesJointes.voir')} : ${piece.nom}`}
            title={piece.nom}
            className="inline-flex max-w-full items-center gap-1.5 text-left text-xs font-medium text-[--color-primary] hover:underline"
          >
            <FaPaperclip className="flex-shrink-0" aria-hidden="true" />
            <span className="max-w-[11rem] truncate">{piece.nom}</span>
          </button>
        ))}
      </span>
      {erreur && (
        <span role="alert" className="text-xs text-red-700">{t('piecesJointes.indisponible')}</span>
      )}
    </span>
  );
}

export default PiecesJointes;
